import { render, staticRenderFns } from "./CurveExam.vue?vue&type=template&id=68d7fc43"
import script from "./CurveExam.vue?vue&type=script&lang=js"
export * from "./CurveExam.vue?vue&type=script&lang=js"
import style0 from "./CurveExam.vue?vue&type=style&index=0&id=68d7fc43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports